export const CONTENT_DATES = {
  published: '2025-01-01',
  updated: '2026-03-07',
};

const SEO_TITLES = {
  'zh-TW': '木魚敲擊遊戲｜免費線上祈福、冥想放鬆、自動敲擊與成就收集遊戲',
  'en-US': 'Mokugyo Clicker Game | Free Meditation and Blessing Game',
  'ja-JP': '木魚叩きゲーム｜無料オンライン祈願・瞑想・実績収集ブラウザゲーム',
};

const QUESTION_HEADINGS = {
  'zh-TW': {
    'about.title': '誰製作了木魚敲擊遊戲？',
    'help.title': '木魚敲擊遊戲要怎麼玩？',
    'typeStats.title': '各祈福類型分別敲擊了多少次？',
    'help.controls.title': '可以用哪些方式操作木魚？',
    'help.achievements.rarity': '成就分為哪些稀有度等級？',
    'help.shortcuts.title': '可以使用哪些鍵盤快捷鍵？',
  },
  'en-US': {
    'about.title': 'Who created the Mokugyo Clicker Game?',
    'help.title': 'How do you play the Mokugyo Clicker Game?',
    'typeStats.title': 'How many times have you tapped each blessing type?',
    'help.controls.title': 'How can you control the mokugyo?',
    'help.achievements.rarity': 'What achievement rarity levels are there?',
    'help.shortcuts.title': 'Which keyboard shortcuts can you use?',
  },
  'ja-JP': {
    'about.title': '木魚叩きゲームは誰が制作しましたか？',
    'help.title': '木魚叩きゲームはどうやって遊びますか？',
    'typeStats.title': '祈福タイプごとに何回タップしましたか？',
    'help.controls.title': '木魚はどのように操作できますか？',
    'help.achievements.rarity': '実績にはどのレアリティがありますか？',
    'help.shortcuts.title': 'どのキーボードショートカットを使用できますか？',
  },
};

const DATE_LABELS = {
  'zh-TW': {
    published: '發布日期',
    updated: '最後更新',
    separator: '與',
    punctuation: '：',
    locale: 'zh-TW',
  },
  'en-US': {
    published: 'Published',
    updated: 'Last updated',
    separator: 'and',
    punctuation: ': ',
    locale: 'en-US',
  },
  'ja-JP': {
    published: '公開日',
    updated: '最終更新',
    separator: 'と',
    punctuation: '：',
    locale: 'ja-JP',
  },
};

export const getSeoTitle = (language = 'zh-TW') => {
  return SEO_TITLES[language] || SEO_TITLES['zh-TW'];
};

export const getQuestionHeading = (key, language = 'zh-TW') => {
  return (
    QUESTION_HEADINGS[language]?.[key] ||
    QUESTION_HEADINGS['zh-TW']?.[key] ||
    null
  );
};

export const getContentDateLabels = (language = 'zh-TW') => {
  return DATE_LABELS[language] || DATE_LABELS['zh-TW'];
};